/** @description 交换位置组件 */

import { Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

type ExchangeIconProps = {
  onSort: () => void;
  style?: React.CSSProperties;
  rotateStyle?: React.CSSProperties;
}

const defaultStyle = {
  bottom: '-10px',
  left: 28,
} as React.CSSProperties;

const defaultRotateStyle = {
  transform: 'rotate(-90deg)'
} as React.CSSProperties;

const ExchangeIcon: React.FC<ExchangeIconProps> = ({ onSort, style=defaultStyle, rotateStyle=defaultRotateStyle }) => {
  const exchangeIconStyle = {
    color: '#777',
    ...rotateStyle,
  } as React.CSSProperties;
  const exchangeWrapperStyle = {
    position: 'absolute',
    height: 20,
    width: 20,
    borderRadius: '50%',
    border: '1px solid #777',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    cursor: 'pointer',
    zIndex: 100,
    ...style
  } as React.CSSProperties;

  return <Tooltip title="交换位置">
    <div style={exchangeWrapperStyle} onClick={onSort}>
      <SwapOutlined style={exchangeIconStyle}/>
    </div>
  </Tooltip>
}

export default ExchangeIcon;